import { useContext, useEffect, useState } from 'react'
import ApplicationContext from 'contexts/application-context'
import DropDown from 'components/DropDown'
import { useAnimation } from 'framer-motion'
import { useInView } from "react-intersection-observer"

import {
  Wrapper,
  Background,
  Title,
  Filters
} from './Styles'
import Input from 'components/Input'
import SearchIcon from 'components/StaticIcons/Search'
import { Theme } from 'theme'

export default function FilterBar() {

  const ApplicationCtx = useContext(ApplicationContext)
  
  // const control = useAnimation()
  // const [ref, inView] = useInView({
  //   rootMargin: '-30%'
  // })

  // const [scroll, setScroll] = useState(0)

  // useEffect(() => {

  //   // eslint-disable-next-line no-restricted-globals
  //   addEventListener('scroll', () => {
  //     setScroll(Number(document.querySelector("html")?.scrollTop))
  //   })

  //   // eslint-disable-next-line no-restricted-globals
  //   return removeEventListener('scroll', () => {})

  // }, [])

  // useEffect(() => {
  //   console.log(inView)
  //   if (scroll > 100) {
  //     control.start("end");
  //   } else {
  //     control.start("start");
  //   }
  // }, [control, inView]);

  // const infoAnimation = { ...Theme.motion.default, delay: 0.1 }

  // const test = {
  //   start: {
  //     // opacity: 0,
  //     y: 0
  //   },
  //   end: {
  //     // opacity: 1,
  //     y: 150
  //   }
  // }

  // const WrapperClasses = []
  // if (scroll > 100) {
  //   WrapperClasses.push('test')
  // }

  return (
    <Wrapper
      // ref={ref}
      // variants={test} initial="start" animate={control} transition={infoAnimation}
      // className={WrapperClasses.join(' ')}
    >
      <Title>Find the best of the best to play together</Title>
      <Filters>
        <Input leftElement={<SearchIcon />} placeholder="Search teammate..." />
        <DropDown title="Rank" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Best agent" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Main agent" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Second agent" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Goal" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Language" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Server" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
        <DropDown title="Location" items={[{ id: 1, title: 'test' }]} activeId={-1} setActiveId={() => { }} />
      </Filters>
      <Background game={ApplicationCtx.game} />
    </Wrapper>
  )
}